module.exports = __webpack_public_path__ + "static/media/davos_slider_5.2fc68ec0.jpg";